import classNames from 'clsx'
import { bool } from 'prop-types'

import Button from 'views/components/atoms/Button'

import './ButtonImage.scss'

const ButtonImage = props => {
  const { children, thumbnail, noBorder, className, ...rest } = props

  const classname = classNames('a-Button--image', className, {
    'a-Button--image-thumbnail': thumbnail,
    'a-Button--image-no-border': noBorder,
  })

  return (
    <Button {...rest} className={classname}>
      {children}
    </Button>
  )
}

ButtonImage.propTypes = {
  ...Button.propTypes,
  thumbnail: bool,
  noBorder: bool,
}

ButtonImage.defaultProps = {
  ...Button.defaultProps,
  thumbnail: null,
  noBorder: null,
}

export default ButtonImage
